var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFullscreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.82005 15.69C6.01005 15.88 5.95004 16.09 5.68004 16.13L0.620041 16.9699C0.440041 17.0199 0.250059 16.91 0.200059 16.73C0.180059 16.67 0.180059 16.61 0.200059 16.56L1.04002 11.5C1.08002 11.23 1.28003 11.16 1.48003 11.36L2.93004 12.81L5.75005 9.98996L7.18004 11.42L4.36003 14.24L5.82005 15.69ZM15.7701 0.999973L10.7101 1.83997C10.4401 1.87997 10.3701 2.07997 10.5701 2.27997L12.0201 3.72998L9.20006 6.54996L10.6301 7.97998L13.4501 5.15998L14.9001 6.60996C15.0901 6.79996 15.3001 6.73997 15.3401 6.46997L16.18 1.40998C16.23 1.22998 16.12 1.04996 15.94 0.989963C15.89 0.979963 15.8301 0.979973 15.7701 0.999973Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullscreen);
export default __webpack_public_path__ + "static/media/fullscreen.addd0c7f.svg";
export { ForwardRef as ReactComponent };